export const dncTypes = new Map();
dncTypes.set('open', 'Open for Communication');
dncTypes.set('forget', 'Right to Forget');
dncTypes.set('restrict', 'Right to Restrict');
dncTypes.set('delete', 'Right to Erase');
